module.exports = Ember.Component.extend({
    isUserInitiated: function() {
        return this.get('entry.properties.origin') === 'user'
    }.property('entry.properties.origin')
})
